import { useContext } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const OnboardingSalesRealProperty = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	
	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, onboardingSalesRealProperty: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}
	
	const steps = [
		{
			target: '.onboardingSalesRealPropertyFirstStep',
			title: "Inquiries Category",
			content: 'This section shows all clients with inquiries.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.onboardingSalesRealPropertySecondStep',
			title: "Property Inquiries Category",
			content: 'This section displays clients who have inquiries on property.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.onboardingSalesRealPropertyThirdStep',
			title: "Agent Application Category",
			content: 'This section shows client who is interested in becomg an agent.',
			disableBeacon: true,
			placement: "bottom",
		},
	]

	return (
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.onboardingSalesRealProperty)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="onboardingSalesRealProperty" 
			featureName="sales"
		/>
	);
}
